import { ProgressTrackerGroup } from 'models/account';
import { ProgressTrackerGroups, ProgressTrackerStages } from 'services/account';
import { ENTITY_MAPPING } from 'constants/common';
import { getLatestStatus, findByGroupAndStage } from 'helpers/progressTracker';
import i18n from 'translations/i18n';
import { getCurrentCommentByUpdatedAt } from './util';

export const initialState = (entityType: string, isTaxOnly: boolean) => ({
  [ProgressTrackerStages.UploadIdentityProof]: {
    data: {},
    status: null,
    label: i18n.t(
      'progressTracker.accountVerification.uploadIdentityProofStep',
    ),
    comment: '',
  },
  [ProgressTrackerStages.UploadLastYearTaxStatement]: {
    data: {},
    status: null,
    label: i18n.t(
      'progressTracker.accountVerification.uploadLastYearTaxStatementStep',
    ),
    comment: '',
  },
  [ProgressTrackerStages.HomeAddressDetails]: {
    data: {},
    status: null,
    label: i18n.t('progressTracker.accountVerification.homeAddressInfoStep'),
    comment: '',
  },
  ...(entityType !== ENTITY_MAPPING.sole_prop && {
    [ProgressTrackerStages.DocumentOfIncorporation]: {
      data: {},
      status: null,
      label: i18n.t(
        'progressTracker.accountVerification.documentOfIncorporationStep',
      ),
      comment: '',
    },
  }),
  ...(!isTaxOnly && {
    [ProgressTrackerStages.DirectDepositInformation]: {
      data: {},
      status: null,
      label: i18n.t(
        'progressTracker.accountVerification.directDepositInfoStep',
      ),
      comment: '',
    },
  }),
});

export const initialStateBIB = () => ({
  [ProgressTrackerStages.UploadIdentityProof]: {
    data: {},
    status: null,
    label: i18n.t(
      'progressTracker.accountVerification.uploadIdentityProofStep',
    ),
    comment: '',
  },
  [ProgressTrackerStages.UploadLastYearTaxStatement]: {
    data: {},
    status: null,
    label: i18n.t(
      'progressTracker.accountVerification.uploadLastYearTaxStatementStep',
    ),
    comment: '',
  },
  [ProgressTrackerStages.HomeAddressDetails]: {
    data: {},
    status: null,
    label: i18n.t('progressTracker.accountVerification.homeAddressInfoStep'),
    comment: '',
  },
});

export const reducer = (
  state: any,
  action: { type: ProgressTrackerStages; value: ProgressTrackerGroup[] },
) => {
  switch (action.type) {
    case ProgressTrackerStages.UploadIdentityProof: {
      const data = findByGroupAndStage(action.value, {
        group: ProgressTrackerGroups.AccountVerification,
        stage: ProgressTrackerStages.UploadIdentityProof,
      });

      return {
        ...state,
        [ProgressTrackerStages.UploadIdentityProof]: {
          ...state[ProgressTrackerStages.UploadIdentityProof],
          data,
          ...getLatestStatus(data?.status),
          comment: getCurrentCommentByUpdatedAt(data?.status),
        },
      };
    }
    case ProgressTrackerStages.UploadLastYearTaxStatement: {
      const data = findByGroupAndStage(action.value, {
        group: ProgressTrackerGroups.AccountVerification,
        stage: ProgressTrackerStages.UploadLastYearTaxStatement,
      });

      return {
        ...state,
        [ProgressTrackerStages.UploadLastYearTaxStatement]: {
          ...state[ProgressTrackerStages.UploadLastYearTaxStatement],
          data,
          ...getLatestStatus(data?.status),
          comment: getCurrentCommentByUpdatedAt(data?.status),
        },
      };
    }
    case ProgressTrackerStages.DocumentOfIncorporation: {
      const data = findByGroupAndStage(action.value, {
        group: ProgressTrackerGroups.AccountVerification,
        stage: ProgressTrackerStages.DocumentOfIncorporation,
      });

      return state[ProgressTrackerStages.DocumentOfIncorporation]
        ? {
            ...state,
            [ProgressTrackerStages.DocumentOfIncorporation]: {
              ...state[ProgressTrackerStages.DocumentOfIncorporation],
              data,
              ...getLatestStatus(data?.status),
              comment: getCurrentCommentByUpdatedAt(data?.status),
            },
          }
        : state;
    }
    case ProgressTrackerStages.DirectDepositInformation: {
      const data = findByGroupAndStage(action.value, {
        group: ProgressTrackerGroups.AccountVerification,
        stage: ProgressTrackerStages.DirectDepositInformation,
      });

      return {
        ...state,
        [ProgressTrackerStages.DirectDepositInformation]: {
          ...state[ProgressTrackerStages.DirectDepositInformation],
          data,
          ...getLatestStatus(data?.status),
          comment: getCurrentCommentByUpdatedAt(data?.status),
        },
      };
    }
    case ProgressTrackerStages.HomeAddressDetails: {
      const data = findByGroupAndStage(action.value, {
        group: ProgressTrackerGroups.AccountVerification,
        stage: ProgressTrackerStages.HomeAddressDetails,
      });

      return {
        ...state,
        [ProgressTrackerStages.HomeAddressDetails]: {
          ...state[ProgressTrackerStages.HomeAddressDetails],
          data,
          ...getLatestStatus(data?.status),
          comment: getCurrentCommentByUpdatedAt(data?.status),
        },
      };
    }
    default:
      return state;
  }
};
